"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ProductNoPlan;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _reactNative = require("react-native");
var _styles = require("@sart/styles");
var _content = require("@sart/content");
var _Space = _interopRequireDefault(require("./Space"));
var _Button = _interopRequireDefault(require("./Button"));
var _Description = _interopRequireDefault(require("./Description"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function ProductNoPlan(props) {
  var onPress = props.onPress,
    titleStyle = props.titleStyle,
    style = props.style,
    buttonStyle = props.buttonStyle,
    buttonTitle = props.buttonTitle,
    description = props.description,
    containerStyle = props.containerStyle;
  var content = (0, _content.useContent)();
  return /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: [styles.container, containerStyle]
  }, /*#__PURE__*/_react["default"].createElement(_Description["default"], {
    style: [styles.description, style]
  }, description), /*#__PURE__*/_react["default"].createElement(_Space["default"], {
    height: 24
  }), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    title: buttonTitle,
    onPress: onPress,
    titleStyle: titleStyle,
    style: buttonStyle
  }));
}
var styles = _reactNative.StyleSheet.create({
  container: _objectSpread({
    padding: 24,
    backgroundColor: _styles.backgroundColors.clear,
    borderRadius: _styles.radius.medium,
    elevation: 8
  }, _styles.shadows.shadowByElevation(8)),
  description: {
    textAlign: 'center'
  }
});